import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from './../../../core/models/response-api';
import { environment } from './../../../../environment/environment';
import { CrudService } from '../crud-service/crud.service';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }
  getAllListOfMonthsOfYear(params: { year?: number; client_id?: number } = {}) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/TimeSheet/getListOfMonthsForYearOfTimeSheetForClient?year=${params.year}&client_id=${params.client_id}`
    );
  }
  searshtimesheet(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/TimeSheet/searchinListOfMonthsForYearofTimeSheetForClient`,
      data
    );
  }
  getAllListOfMonths(
    params: { month?: number; year?: number; client_id?: number } = {}
  ) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/TimeSheet/getListOfTimeSheetsForMonthByClient?month=${params.month}&year=${params.year}&client_id=${params.client_id}`
    );
  }
  searshtimesheetmonth(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/TimeSheet/searchinListOfTimeSheetForMonthByClient`,
      data
    );
  }
  getDetailsTimeSheet(idtimesheet: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/TimeSheet/getDetailsTimeSheet?id=${idtimesheet}`
    );
  }
  getDetailtimesheetJourfeerie(
    country: any,
    idtimesheet: any,
    company_id: any
  ) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/TimeSheet/getDetailsTimeSheet?country=fr&id=${idtimesheet}&company_id=${company_id}`
    );
  }
  getProjetByCandidate(id:any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Project/listProjectsByCandidate?id=${id}`
    );
  }
  getStateOfftimesheet(idTimeSheet: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/TimeSheet/StateOfTimeSheet?TimeSheet_id=${idTimeSheet}`
    );
  }
  getListOfTimeSheet() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/TypeOfCra/getListWithoutPaginate`
    );
  }
  /*nv web service*/
  getListOfTimeSheet1() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/TypeOfCra/getListWithoutPaginate`
    );
  }

  /*get list timesheet*/

  // getAllListtimesheet(clientFinal_id:any) {

  //   return this._http.get<ApiResponse<any>>(this._base + `/TimeSheet/getListTimeSheetByClientFinal?clientFinal_id=${clientFinal_id}&per_page=5&page=1`);
  // }
  getAllListtimesheet(
    clientFinal_id: any,
    data: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute?: string;
    }
  ) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;

    return this._http.get<ApiResponse<any>>(
      `${this._base}/TimeSheet/getListTimeSheetByClientFinal?clientFinal_id=${clientFinal_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }
  /* search Timesheet */
  searchTimesheet(data: any, clientFinal_id: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/TimeSheet/searchInlistTimeSheetByClient?clientFinal_id=${clientFinal_id}`,
      data
    );
  }
  /*get list type activité*/

  getAllTypeactivité(company_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/SpecificTypeOfCra/getListWithoutPaginate?company_id=${company_id}`
    );
  }

  rejectAndValidateCra(data: any, companyId: any, userId: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/TimeSheet/validateTimeSheetWithWorkflow?company_id=${companyId}&user_id=${userId}`,
      data
    );
  }
  //detail timesheet liste type activité
  getAllTypeactivitétimesheet(company_name: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/TypeOfTimeSheet/getListWithoutPaginate?company_name=${company_name}`
    );
  }
}
